import { PageResponse } from '@payer-admin-ui/api/src/utils/repository/PageResponse';
import { wrappedApiGet } from '../utils/http';

export type PaymentTerminal = {
  id: string;
  terminalName?: string | null;
  created?: string | null;
  [key: string]: any;
};

export type PaymentTerminalStatus = string;

export type FetchPaymentTerminalsParams = {
  page: number;
  pageSize: number;
  filters?: {
    statuses?: PaymentTerminalStatus[];
    search?: string;
    [key: string]: any;
  };
  sort?: string[];
};

export const paymentTerminalsAPI = {
  fetchPage: async ({
    page,
    pageSize,
    filters = {},
    sort,
  }: FetchPaymentTerminalsParams): Promise<PageResponse<PaymentTerminal>> => {
    const { statuses, ...rest } = filters;
    return await wrappedApiGet<PageResponse<PaymentTerminal>>(`/pos/terminals`, {
      query: {
        offset: page * pageSize,
        pageSize,
        status: statuses,
        sort,
        ...rest,
      },
    }).withObjectResponse();
  },
};
